import { render } from "./LegalPayAmount.vue?vue&type=template&id=6fcf633e"
import script from "./LegalPayAmount.vue?vue&type=script&lang=js"
export * from "./LegalPayAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__